import React, { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { Box } from 'components';
import { Spinner } from 'components/shared';
import { getProfileId } from 'utils';
import growApi from '../../api';
import { makeQueryFetch } from '../../api/util';

const ChurnRate = () => {
  // const { } = useContext(EmployerGrowContext);
  const client = useApolloClient();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [rate, setRate] = useState(0);

  const fetchData = async () => {
    const profileId = Number(getProfileId());

    if (profileId) {
      setIsDataLoading(true);

      const data = await makeQueryFetch(
        {
          query: growApi.query.EMPLOYER_CHURN_RATE,
          path: 'getChurnRateEmployer',
          variables: { employerProfileProfileId: profileId },
        },
        client,
      );

      if (data?.churnRateEmployer)
        setRate(data.churnRateEmployer);

      setIsDataLoading(false);
    } else {
      throw new Error(
        'getHiringRateEmployer error: profileId is not defined',
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="chartCard">
      {isDataLoading && (
        <div className="chartLoaderContainer">
          <Spinner size={48} />
        </div>
      )}
      <h4 className="chartTitle">Employee Churn Rate</h4>
      <Box pt="20px">
        <p className="chartDescription">
          The amount of participants that leave or are looking
          for new opportunities within 1 year.
        </p>
        <div className="chartValue_big">{`${rate}%`}</div>
      </Box>
    </div>
  );
};

export default ChurnRate;
